import { createAppSelector } from 'wanderu-ducks-utils';

import SLICE_NAMESPACE from '../../../types';
import { serializeFilterParams } from '../../../utils';
import {
    selectReduxSearchParams,
} from '../../search/selectors';
import {
    minimizeFilterSet,
    writeFilterQueryParams,
} from '../filterUtils';
import { INITIAL_SUBSTATE } from '../reducer';
import NAMESPACE from '../types';

function _selectData(state) {
    return state[SLICE_NAMESPACE][NAMESPACE];
}

function selectRawFilterData(state, filterId) {
    return _selectData(state)[filterId] || INITIAL_SUBSTATE;
}

function selectFilterId(state, searchParams) {
    const resolvedParams = searchParams || selectReduxSearchParams(state);
    return serializeFilterParams(resolvedParams);
}

function selectFilterData(state, searchParams) {
    const filterId = selectFilterId(state, searchParams);
    return selectRawFilterData(state, filterId);
}

const selectFilterQueryParams = createAppSelector(
    [
        (state, filterId) => selectRawFilterData(state, filterId),
        (_, _filterId, direction) => direction,
    ],
    (rawFilterData, direction) => {
        const minimunFilterSet = minimizeFilterSet(rawFilterData);
        return writeFilterQueryParams(minimunFilterSet, direction);
    },
);

export {
    selectFilterData,
    selectFilterId,
    selectFilterQueryParams,
    selectRawFilterData,
};
